import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@/api/errors'

/**
 * App-wide TanStack Query defaults. Tuned for a compliance app:
 *   - short stale (30s) so approvals/edits in the Flutter app during parallel
 *     running surface on the next filter change or window focus
 *   - retry only on 5xx; never on 4xx (bad request stays bad)
 *   - no background refetch on window focus for mutations
 *   - queries retry once with 1s backoff
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.statusCode >= 400 && error.statusCode < 500) {
          return false
        }
        return failureCount < 1
      },
      retryDelay: 1_000,
    },
    mutations: {
      retry: false,
    },
  },
})
